import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

import TextArea from "@app/component/input/TextArea";
import configService from "@app/config/ConfigService";
import { cumulDemoRequest } from "@app/store/cumul/actions";

import styles from "./DemoRequestModal.module.scss";

interface Props {
  hideModal: (visible: boolean) => void;
  onCumulDemoRequest: typeof cumulDemoRequest.request;
  visible: boolean;
}

const DemoRequestModal: React.FC<Props> = ({ hideModal, onCumulDemoRequest, visible }) => {
  const intl = useIntl();

  useEffect(() => {
    if (!window.grecaptcha) {
      const RECAPTCHA_SITE_KEY = configService.getRecaptchaSiteKey();
      const scriptTag = document.createElement("script");
      scriptTag.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      scriptTag.async = true;
      scriptTag.defer = true;
      document.body.append(scriptTag);
    }
  }, []);

  const [demoMessage, setDemoMessage] = useState<string>("");

  const handleSubmitDemoRequest = useCallback(() => {
    onCumulDemoRequest({ message: demoMessage });
    setDemoMessage("");
    hideModal(false);
  }, [onCumulDemoRequest, demoMessage, hideModal, setDemoMessage]);

  return (
    <Modal
      cancelButtonProps={{ hidden: true }}
      centered
      className={styles.demoModal}
      okText={intl.formatMessage({
        id: "reports.customDashboards.upgradeYourReports.demoModal.okButton",
        defaultMessage: "Submit Request For Demo",
        description: "Submit button title for getting demo when called from Cumul Promotion modal",
      })}
      onCancel={() => hideModal(false)}
      onOk={handleSubmitDemoRequest}
      title={intl.formatMessage({
        id: "reports.customDashboards.upgradeYourReports.demoModal.title",
        defaultMessage: "Custom Dashboards",
        description: "Title of demo modal",
      })}
      visible={visible}
    >
      <TextArea
        autoSize={false}
        label={intl.formatMessage({
          id: "reports.customDashboards.upgradeYourReports.demoModal.label",
          defaultMessage: "Tell us more about what you’re looking for",
        })}
        labelClassName={styles.textField}
        onChange={setDemoMessage}
        placeholder={intl.formatMessage({
          id: "reports.customDashboards.upgradeYourReports.demoModal.placeholder",
          defaultMessage: "Enter here...",
          description: "Placeholder for textarea",
        })}
        rows={6}
        value={demoMessage}
      />
    </Modal>
  );
};

const mapDispatchToProps = {
  onCumulDemoRequest: cumulDemoRequest.request,
};

export default connect(null, mapDispatchToProps)(DemoRequestModal);
